export default __webpack_public_path__ + "media/cuttlefish/proBadge-68391bb1.svg";